import { Component, Input, input, ChangeDetectionStrategy } from '@angular/core';
import { NgStyle, NgClass } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'customer-app-fv-left',
  templateUrl: './fv-left.component.html',
  styleUrls: ['./fv-left.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgStyle, NgClass, TranslatePipe]
})
export class FvLeftComponent {
  @Input() image: string;
  @Input() text: { headline: string; text: string };
  readonly needsColumn = input(false);
  readonly maxHeight = input('calc(100vh - 210px)');
  readonly maxWidth = input('1000px');
  readonly imageMaxWidth = input('350px');
}
